var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('v-alert',{staticClass:"custom-alert",attrs:{"type":"error","dense":"","variant":"outlined","width":_vm.alertWidth,"transition":"scroll-y-transition"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }